import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';
import { visuallyFormatPhoneNumber } from '../../../helpers/general';
import { modifyObject } from '../../../helpers/modifyObject';
import Validator from '../../common/forms/Validator';
import ErrorMessage from '../../common/forms/ErrorMessage';
import Close from '../../common/ui/Close';
import FormActionButtons from '../../common/forms/FormActionButtons';

export default class CreateAdmin extends Validator {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggleCreateModal: PropTypes.func.isRequired,
    createAdminUser: PropTypes.func.isRequired,
    getAdminList: PropTypes.func.isRequired
  };

  initialState = {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    phone: '',
    isPristine: true
  };

  validationRules = {
    first_name: { required: true },
    last_name: { required: true },
    email: { required: true },
    phone: { required: true },
    password: { password: true }
  };

  state = this.initialState;

  handleChange = event => {
    this.setFormIsTouched();

    this.setState({
      [event.target.name]: event.target.value
    });
  };

  handleChangePhone = event => {
    const { value } = event.target;
    this.setState({
      phone: visuallyFormatPhoneNumber(value)
    });
  };

  submitCreateAdmin = event => {
    event.preventDefault();

    if (this.validate(this.validationRules)) {
      const { createAdminUser, toggleCreateModal, getAdminList } = this.props;
      const { first_name, last_name, email, password, phone } = this.state;
      const adminData = {
        first_name,
        last_name,
        email,
        password,
        phone
      };
      createAdminUser(modifyObject(adminData)).then(() => {
        this.setState(this.initialState);
        toggleCreateModal();
        getAdminList(0);
      });
    }
  };

  clearForm = () => {
    this.setState(this.initialState);
    this._resetErrors();
  };

  componentDidUpdate (prevProps) {
    if (!this.props.isOpen && prevProps.isOpen) {
      this.clearForm();
    }
  }

  render () {
    const { isOpen, toggleCreateModal } = this.props;
    const { first_name, last_name, email, password, phone } = this.state;
    const errors = this.validationErrors;

    return (
      <Modal isOpen={isOpen} toggle={toggleCreateModal}>
        <div className='modal-header'>
          <div className='modal-title'>Create New Admin</div>
          <Close onClick={toggleCreateModal} />
        </div>
        <ModalBody>
          <form onSubmit={this.submitCreateAdmin}>
            <div className='form-group'>
              <label htmlFor='first_name'>First Name</label>
              <input className='input' id='first_name'
                name='first_name' type='text' onChange={this.handleChange} value={first_name} />
              <ErrorMessage errorText={errors.first_name} />
            </div>
            <div className='form-group'>
              <label htmlFor='last_name'>Last Name</label>
              <input className='input' id='last_name'
                name='last_name' type='text' onChange={this.handleChange} value={last_name} />
              <ErrorMessage errorText={errors.last_name} />
            </div>
            <div className='form-group'>
              <label htmlFor='email'>E-mail</label>
              <input className='input' id='email'
                name='email' type='email' onChange={this.handleChange} value={email} />
              <ErrorMessage errorText={errors.email} />
            </div>
            <div className='form-group'>
              <label htmlFor='password'>Password</label>
              <input className='input' id='password'
                name='password' type='password' onChange={this.handleChange} value={password} />
              <ErrorMessage errorText={errors.password} />
            </div>
            <div className='form-group'>
              <label htmlFor='phone'>Phone Number</label>
              <input className='input' id='phone'
                name='phone' type='tel' onChange={this.handleChangePhone} value={phone} />
              <ErrorMessage errorText={errors.phone} />
            </div>

            <FormActionButtons onClickCancel={toggleCreateModal} submitTitle='Create' isSubmitDisabled={this.isPristine} />
          </form>
        </ModalBody>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/admins/CreateAdmin.js